const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Alba
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba',
    name: 'alba-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Alba',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Alba !<br />Avec ses lettres étroites et régulières, la police d'écriture Alba est à la fois moderne et élégante.",
      tags: ['set-tampon-alphabet-alba'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/alba/alba-set-complet.jpg'),
          name: 'Alba',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/set-complet-alba',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/alba/alba-majuscules.jpg'),
          name: 'Alba',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/majuscules-alba',
        },
        {
          src: require('../../../public/img/materiel-creatif/alba/alba-minuscules.jpg'),
          name: 'Alba',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/minuscules-alba',
        },
        {
          src: require('../../../public/img/materiel-creatif/alba/alba-speciaux.jpg'),
          name: 'Alba',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/speciaux-chiffres-alba',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/set-complet-alba',
    name: 'full-set-alba',
    component: () =>
      import('../../pages/products/creative/Alba/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/alba/alba-set-complet.jpg'),
      type: 'Set complet Alba',
      hiddenType: 'alba-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-alba'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/majuscules-alba',
    name: 'uppercase-alba',
    component: () =>
      import('../../pages/products/creative/Alba/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/alba/alba-majuscules.jpg'),
      type: 'Jeu de majuscules Alba',
      hiddenType: 'alba-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-alba'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/minuscules-alba',
    name: 'lowercase-alba',
    component: () =>
      import('../../pages/products/creative/Alba/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/alba/alba-minuscules.jpg'),
      type: 'Jeu de minuscules Alba',
      hiddenType: 'alba-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-alba'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba/speciaux-chiffres-alba',
    name: 'specials-numbers-alba',
    component: () =>
      import('../../pages/products/creative/Alba/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/alba/alba-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Alba',
      hiddenType: 'alba-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-alba'],
    },
  },
];
